// extracted by mini-css-extract-plugin
export var sliderRange = "_nn-2";
export var sliderRoot = "_nn-0";
export var sliderThumb = "_nn-3";
export var sliderTrack = "_nn-1";